import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import generateSalePDF from '../sale/Bill';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import '../shared.css';

const SaleEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [promoDiscountMessage, setPromoDiscountMessage] = useState('');
    const [promoDiscountOptions, setPromoDiscountOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [confirmRemove, setConfirmRemove] = useState(null);

    // Function to set promotional discount message with auto-clear timeout
    const setPromoDiscountMessageWithTimeout = (message) => {
        setPromoDiscountMessage(message);
        setTimeout(() => setPromoDiscountMessage(''), 1000);
    };
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate, roleName } = useAuth();
    const [selectedGWPorPWP, setSelectedGWPorPWP] = useState(false);

    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);

    const [selectedDiscType, setSelectedDiscType] = useState("");
    const [dropdownDiscTypeOptions, setDropdownDiscTypeOptions] = useState([]);

    const [selectedCardType, setSelectedCardType] = useState("");
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    const [showCardFields, setShowCardFields] = useState(false);
    const [showupiFields, setShowupiFields] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
        fetchDropdownDiscTypeOptions();
        promotionalSlab();
    }, []);

    const promotionalSlab = () => {
        fetchData('SaleApi', `/PromoSlab/${companyId}/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setPromoDiscountOptions(response.response_data || []);
                }
            })
            .catch((error) => {
                console.error('Error fetching promotional discount options:', error);
            });
    };


    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchDropdownDiscTypeOptions = () => {
        fetchData('SaleApi', `/DiscType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownDiscTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };


    const fetchDropdownCardTypeOptions = () => {
        fetchData('SaleApi', `/CardType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownCardTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Card Type dropdown options:', error);
            });
    };

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);



    useEffect(() => {
        fetchData('SaleApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setInvoicedeatils(response.response_data.SaleDetails);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));

                    setSelectedSalesMan(response.response_data.Sale.SalesManId);
                    setSelectedCardType(response.response_data.Sale.CardType);
                    setSelectedDiscType(response.response_data.Sale.DiscTypeId);
                    setSelectedGWPorPWP(response.response_data.Sale.GWPorPWPIncluded);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    // Function to automatically select promotional discount percentage based on discounted item quantity
    const getAutoPromotionalDiscount = (discountedItemsCount) => {
        console.log('Debug - Discounted Items Count:', discountedItemsCount);
        console.log('Debug - Promo Discount Options:', promoDiscountOptions);

        if (!promoDiscountOptions || promoDiscountOptions.length === 0) {
            return 0;
        }

        // Sort options by MinimumQuantity in descending order to get the highest applicable discount
        const sortedOptions = [...promoDiscountOptions].sort((a, b) => b.MinimumQuantity - a.MinimumQuantity);
        console.log('Debug - Sorted Options:', sortedOptions);

        // Find the first option where discounted items count meets the minimum quantity requirement
        const applicableOption = sortedOptions.find(option => {
            const isApplicable = discountedItemsCount >= option.MinimumQuantity;
            console.log(`Debug - Checking option: ${option.DiscountPercentage}% (MinQty: ${option.MinimumQuantity}) - ${discountedItemsCount} >= ${option.MinimumQuantity} = ${isApplicable}`);
            return isApplicable;
        });

        console.log('Debug - Selected Option:', applicableOption);
        return applicableOption ? applicableOption.DiscountPercentage : 0;
    };

    // Validate if promotional discount should be applied based on quantity threshold
    const validatePromoDiscountEligibility = (invoiceDetails, promoDiscountQuantity) => {
        // Handle edge cases
        if (!invoiceDetails || !Array.isArray(invoiceDetails) || invoiceDetails.length === 0) {
            return false;
        }

        // Validate PromoDiscountQuantity is non-negative integer
        const validatedQuantity = parseInt(promoDiscountQuantity) || 0;
        if (validatedQuantity < 0) {
            return false;
        }

        // Count items with DiscountPercentage > 0
        const discountedItemsCount = invoiceDetails.filter(item => {
            const discountPercentage = parseFloat(item.DiscountPercentage);
            return !isNaN(discountPercentage) && discountPercentage > 0;
        }).length;

        // If PromoDiscountQuantity is not set or is 0, allow promotional discount
        if (validatedQuantity === 0) {
            return true;
        }

        return discountedItemsCount >= validatedQuantity;
    };

    // Extracted recalculation logic into a separate function for efficiency
    const recalculateInvoiceDetails = (currentFormData) => {
        const AdditionalDisc = parseFloat(currentFormData.AdditionalDiscountPercentage) || 0;

        const updatedItemData = invoicedeatils.map((item) => {
            const rate = parseFloat(item.Rate) || 0;
            const gstrate = parseFloat(item.GSTRate) || 0;
            const discountPercentage = parseFloat(item.DiscountPercentage) || 0;
            const quantity = parseFloat(item.Quantity) || 0;

            // Calculate amounts
            const amount = (quantity * rate).toFixed(2);
            const discamt = ((rate * discountPercentage) / 100).toFixed(2);
            const Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
            const totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
            const grate = (rate - totdiscount).toFixed(2);

            let promodiscountamt = 0;
            let RateAfterDiscount = grate;

            // Auto-calculate promotional discount percentage based on discounted items count
            // Only calculate if promotional discount is enabled
            let autoPromoPercentage = 0;
            if (isPromotionalDiscountEnabled()) {
                // For recalculation, count all items with discounts in the current invoice
                const discountedItemsCount = invoicedeatils.filter(invItem =>
                    parseFloat(invItem.DiscountPercentage) > 0
                ).length;

                autoPromoPercentage = getAutoPromotionalDiscount(discountedItemsCount);

                // Update form data with auto-calculated promotional discount percentage if different
                if (autoPromoPercentage !== parseFloat(currentFormData.PromotionalDiscountPercentage)) {
                    // Update immediately for recalculation context
                    currentFormData.PromotionalDiscountPercentage = autoPromoPercentage.toString();

                    // Also update the main form state
                    setTimeout(() => {
                        setFormData(prevData => ({
                            ...prevData,
                            PromotionalDiscountPercentage: autoPromoPercentage.toString()
                        }));
                    }, 0);
                }
            }

            let promodiscPercentage = autoPromoPercentage;

            // Check if item has discount percentage > 0 and promotional discount is enabled
            if (item.DiscountPercentage > 0 && isPromotionalDiscountEnabled()) {
                const isEligible = validatePromoDiscountEligibility(invoicedeatils, currentFormData.PromoDiscountQuantity);
                if (isEligible) {
                    promodiscountamt = ((grate * promodiscPercentage) / 100).toFixed(2);
                    // Set success message for promotional discount applied
                    if (promodiscPercentage > 0) {
                        setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                    }
                } else {
                    // Set warning message for promotional discount not applied due to quantity
                    const discountedItemsCount = invoicedeatils.filter(item =>
                        parseFloat(item.DiscountPercentage) > 0
                    ).length;
                    const requiredQuantity = parseInt(currentFormData.PromoDiscountQuantity) || 0;
                    if (requiredQuantity > 0) {
                        setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                    }
                }
            }
            let RateAfterPromotionalDiscount = (RateAfterDiscount - promodiscountamt).toFixed(2);

            const salerate = (RateAfterPromotionalDiscount / (1 + gstrate / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);

            // Calculate GST based on GST Number
            let cgst = 0, sgst = 0, igst = 0;

            if (!currentFormData.GSTNumber) {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            } else {
                const gstNumberPrefix = currentFormData.GSTNumber.toString().substring(0, 2);
                if (gstNumberPrefix !== branchstate) {
                    igst = ((taxableamount * gstrate) / 100).toFixed(2);
                } else {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                }
            }

            const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

            return {
                ...item,
                Amount: amount,
                DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),

                RateAfterDiscount: parseFloat(RateAfterDiscount).toFixed(2),
                // PromotionalDiscountPercentage: parseFloat(promodiscPercentage).toFixed(2),
                PromotionalDiscountPercentage: Number(discountPercentage) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",

                PromotionalDiscountAmount: parseFloat(promodiscountamt).toFixed(2),
                RateAfterPromotionalDiscount: parseFloat(RateAfterPromotionalDiscount).toFixed(2),

                TaxableAmount: parseFloat(taxableamount).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2),
                SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
            };
        });

        setInvoicedeatils(updatedItemData);

        // Calculate totals using reduce for efficiency
        const totals = updatedItemData.reduce((acc, item) => ({
            Quantity: acc.Quantity + parseFloat(item.Quantity),
            Amount: acc.Amount + parseFloat(item.Amount),
            DiscountAmount: acc.DiscountAmount + parseFloat(item.DiscountAmount),
            AddiDiscountAmount: acc.AddiDiscountAmount + parseFloat(item.AdditionalDiscountAmount),
            PromotionalDiscountAmount: acc.PromotionalDiscountAmount + parseFloat(item.PromotionalDiscountAmount),
            TaxableAmount: acc.TaxableAmount + parseFloat(item.TaxableAmount),
            CGSTAmount: acc.CGSTAmount + parseFloat(item.CGSTAmount),
            SGSTAmount: acc.SGSTAmount + parseFloat(item.SGSTAmount),
            IGSTAmount: acc.IGSTAmount + parseFloat(item.IGSTAmount),
            TotalAmount: acc.TotalAmount + parseFloat(item.TotalAmount),
        }), {
            Quantity: 0, Amount: 0, DiscountAmount: 0, AddiDiscountAmount: 0, PromotionalDiscountAmount: 0,
            TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0
        });

        // Get payment amounts
        const gvAmount = parseFloat(currentFormData.GVAmount) || 0;
        const CardAmount = parseFloat(currentFormData.CardAmount) || 0;
        const UPIAmount = parseFloat(currentFormData.UPIAmount) || 0;
        const totalDiscount = totals.DiscountAmount + totals.AddiDiscountAmount;
        const totalPromDiscount = totals.PromotionalDiscountAmount;
        // Call total calculation
        totalCalculation(
            totals.Quantity,
            totals.Amount,
            totalDiscount,
            totalPromDiscount,
            totals.TaxableAmount,
            totals.CGSTAmount,
            totals.SGSTAmount,
            totals.IGSTAmount,
            totals.TotalAmount,
            gvAmount,
            CardAmount,
            UPIAmount
        );
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Fields that require full recalculation
        const recalculationFields = ['GVAmount', 'GSTNumber', 'CardAmount', 'UPIAmount', 'AdditionalDiscountPercentage', 'PromotionalDiscountPercentage'];

        if (recalculationFields.includes(name)) {
            // Update form data first
            const updatedFormData = {
                ...formData,
                [name]: name === 'GSTNumber' ? value :
                    name === 'AdditionalDiscountPercentage' ? parseFloat(value || 0).toFixed(2) :
                        parseFloat(value || 0).toFixed(2),
                ModifiedBy: userId,
            };

            setFormData(updatedFormData);

            // Perform recalculation with updated data
            recalculateInvoiceDetails(updatedFormData);
        } else {
            // Simple field update for other fields
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.CustomerName) {
            setErrorMessage('Customer Name is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.ContactNumber) {
            setErrorMessage('Contact Number is required !');
            setIsLoading(false);
            return;
        }


        // Cash amount validation
        if (formData.CashAmount < 0) {
            setErrorMessage('Cash Amount less than 0 is not allowed!');
            setIsLoading(false);
            return;
        }

        if (!selectedDiscType && formData.AdditionalDiscountPercentage > 0) {
            setErrorMessage('Disc Type is required !');
            setIsLoading(false);
            return;
        }

        if (selectedDiscType == "1" && !formData.SCMembershipNumber) {
            setErrorMessage('SC Membership Number is required !');
            setIsLoading(false);
            return;
        }

        if (selectedDiscType == "2" && !formData.VoucherNumber) {
            setErrorMessage('Voucher Number is required !');
            setIsLoading(false);
            return;
        }

        // Card amount validation
        if (formData.CardAmount > 0) {
            if (!formData.CardNumber) {
                setErrorMessage('Card Number is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
            if (!selectedCardType) {
                setErrorMessage('Card Type is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }

        if (!selectedSalesMan) {
            setErrorMessage('Sales Man is required !');
            setIsLoading(false);
            return;
        }

        // Upi amount validation
        if (formData.UPIAmount > 0) {
            if (!formData.UPINumber) {
                setErrorMessage('UPI Number is required when UPI Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }


        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
            SalesManId: selectedSalesMan,
            CardType: selectedCardType
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: invoicedeatils
        };

        // Validate form data here if needed

        updateData('SaleApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);


                if (response.response === 'Sale Updated Successfully') {
                    const SaleId = response.kotId;
                    handlePrint(SaleId);
                }
                history.push('/SaleIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const handlePrint = async (SaleId) => {
        try {
            const response = await fetchData('SaleApi', `/SalePrint/${SaleId}/${branchId}`, token);
            generateSalePDF(response.response_data);
        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const removeRecord = (index) => {
        setConfirmRemove(index);
    };

    const confirmRemoveRecord = () => {
        const index = confirmRemove;
        setConfirmRemove(null);
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record 

            // Calculate promotional discount percentage based on updated item count
            let autoPromoPercentage = 0;
            if (isPromotionalDiscountEnabled()) {
                const discountedItemsCount = updatedRecords.filter(item =>
                    parseFloat(item.DiscountPercentage) > 0
                ).length;

                autoPromoPercentage = getAutoPromotionalDiscount(discountedItemsCount);

                // Update form data with the new promotional discount percentage
                if (autoPromoPercentage !== parseFloat(formData.PromotionalDiscountPercentage)) {
                    setFormData(prev => ({
                        ...prev,
                        PromotionalDiscountPercentage: autoPromoPercentage
                    }));
                }
            }

            // Recalculate promotional discounts on the updated data
            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
            const recalculatedItems = updatedRecords.map((item) => {
                const rate = parseFloat(item.Rate) || 0;
                const gstrate = parseFloat(item.GSTRate) || 0;
                const discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                const quantity = parseFloat(item.Quantity) || 0;

                // Calculate amounts
                const amount = (quantity * rate).toFixed(2);
                const discamt = ((rate * discountPercentage) / 100).toFixed(2);
                const Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                const totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                const grate = (rate - totdiscount).toFixed(2);

                let promodiscountamt = 0;
                let RateAfterDiscount = grate;
                let promodiscPercentage = autoPromoPercentage; // Use auto-calculated percentage

                // Check if item has discount percentage > 0 and quantity threshold is met
                if (item.DiscountPercentage > 0) {
                    const isEligible = validatePromoDiscountEligibility(updatedRecords, formData.PromoDiscountQuantity);
                    if (isEligible) {
                        promodiscountamt = ((grate * promodiscPercentage) / 100).toFixed(2);
                        // Set success message for promotional discount applied
                        if (promodiscPercentage > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                        }
                    } else {
                        // Set warning message for promotional discount not applied due to quantity
                        const discountedItemsCount = updatedRecords.filter(item =>
                            parseFloat(item.DiscountPercentage) > 0
                        ).length;
                        const requiredQuantity = parseInt(formData.PromoDiscountQuantity) || 0;
                        if (requiredQuantity > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                        }
                    }
                }
                let RateAfterPromotionalDiscount = (RateAfterDiscount - promodiscountamt).toFixed(2);

                const salerate = (RateAfterPromotionalDiscount / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);

                // Calculate GST based on GST Number
                let cgst = 0, sgst = 0, igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);
                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * gstrate) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),

                    RateAfterDiscount: parseFloat(RateAfterDiscount).toFixed(2),
                    PromotionalDiscountPercentage: Number(discountPercentage) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",
                    PromotionalDiscountAmount: parseFloat(promodiscountamt).toFixed(2),
                    RateAfterPromotionalDiscount: parseFloat(RateAfterPromotionalDiscount).toFixed(2),

                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            // Update the invoice details with recalculated promotional discounts
            setInvoicedeatils(recalculatedItems);

            // Calculate totals with the recalculated data
            const Quantity = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const totalPromoDiscount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.PromotionalDiscountAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, totalPromoDiscount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);
    };

    //Items
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            const response = await fetchData('SaleApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Code + '-' + item.Name
                }));
                setItemsrOptions(options);
                setItemDetails(response.response_data);
            }

            setFormData(prevData => ({
                ...prevData,
                BranchId: branchId,
                CompanyId: companyId,
                CreatedBy: userId,
            }));

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemId: '',
        Quantity: '1',
        Rate: '',
        Amount: '',
        DiscountPercentage: '',
        DiscountAmount: '',
        HSNCode: '',
        GSTRate: '',
        TaxableAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        TotalAmount: '',
        balanceStock: 0,
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemId: '',
            Quantity: '1',
            Rate: '',
            Amount: '',
            DiscountPercentage: '',
            DiscountAmount: '',
            HSNCode: '',
            GSTRate: '',
            TaxableAmount: '',
            CGSTAmount: '',
            SGSTAmount: '',
            IGSTAmount: '',
            TotalAmount: '',
            balanceStock: 0,
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }

        if (modalData.Quantity > modalData.balanceStock) {
            isValid = false;
            errors = "Quantity exceeds available stock.";
        }


        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemId: '',
                Quantity: '1',
                Rate: '',
                Amount: '',
                DiscountPercentage: '',
                DiscountAmount: '',
                HSNCode: '',
                GSTRate: '',
                TaxableAmount: '',
                CGSTAmount: '',
                SGSTAmount: '',
                IGSTAmount: '',
                TotalAmount: '',
                balanceStock: 0,
            });

            setSelectedItem(0);
            //closeModal();

            // Calculate promotional discount percentage based on updated item count
            let autoPromoPercentage = 0;
            if (isPromotionalDiscountEnabled()) {
                const discountedItemsCount = updatedInvoicedetailsSorted.filter(item =>
                    parseFloat(item.DiscountPercentage) > 0
                ).length;

                autoPromoPercentage = getAutoPromotionalDiscount(discountedItemsCount);

                // Update form data with the new promotional discount percentage
                if (autoPromoPercentage !== parseFloat(formData.PromotionalDiscountPercentage)) {
                    setFormData(prev => ({
                        ...prev,
                        PromotionalDiscountPercentage: autoPromoPercentage
                    }));
                }
            }

            // Recalculate promotional discounts on the updated data
            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
            const recalculatedItems = updatedInvoicedetailsSorted.map((item) => {
                const rate = parseFloat(item.Rate) || 0;
                const gstrate = parseFloat(item.GSTRate) || 0;
                const discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                const quantity = parseFloat(item.Quantity) || 0;

                // Calculate amounts
                const amount = (quantity * rate).toFixed(2);
                const discamt = ((rate * discountPercentage) / 100).toFixed(2);
                const Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                const totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                const grate = (rate - totdiscount).toFixed(2);

                let promodiscountamt = 0;
                let RateAfterDiscount = grate;
                let promodiscPercentage = autoPromoPercentage; // Use auto-calculated percentage

                // Check if item has discount percentage > 0 and quantity threshold is met
                if (item.DiscountPercentage > 0) {
                    const isEligible = validatePromoDiscountEligibility(updatedInvoicedetailsSorted, formData.PromoDiscountQuantity);
                    if (isEligible) {
                        promodiscountamt = ((grate * promodiscPercentage) / 100).toFixed(2);
                        // Set success message for promotional discount applied
                        if (promodiscPercentage > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                        }
                    } else {
                        // Set warning message for promotional discount not applied due to quantity
                        const discountedItemsCount = updatedInvoicedetailsSorted.filter(item =>
                            parseFloat(item.DiscountPercentage) > 0
                        ).length;
                        const requiredQuantity = parseInt(formData.PromoDiscountQuantity) || 0;
                        if (requiredQuantity > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                        }
                    }
                }
                let RateAfterPromotionalDiscount = (RateAfterDiscount - promodiscountamt).toFixed(2);

                const salerate = (RateAfterPromotionalDiscount / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);

                // Calculate GST based on GST Number
                let cgst = 0, sgst = 0, igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);
                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * gstrate) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),

                    RateAfterDiscount: parseFloat(RateAfterDiscount).toFixed(2),
                    PromotionalDiscountPercentage: Number(discountPercentage) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",
                    PromotionalDiscountAmount: parseFloat(promodiscountamt).toFixed(2),
                    RateAfterPromotionalDiscount: parseFloat(RateAfterPromotionalDiscount).toFixed(2),

                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            // Update the invoice details with recalculated promotional discounts
            setInvoicedeatils(recalculatedItems);

            // Calculate totals with the recalculated data
            const Quantity = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const PromotionalDiscountAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.PromotionalDiscountAmount), 0);
            const TaxableAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const totalPromoDiscount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.PromotionalDiscountAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, totalPromoDiscount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);


        } else {

            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }

    };


    const totalCalculation = (Quantity, Amount, DiscountAmount, totalPromDiscount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount) => {

        const gvAmount = parseFloat(gvamt) || 0;

        let netamount = parseFloat(TaxableAmount);
        let netAmt = netamount + parseFloat(CGSTAmount) + parseFloat(SGSTAmount) + parseFloat(IGSTAmount);
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmt = parseFloat((netAmt + roundOffValue)).toFixed(2);
        totalAmt = parseFloat(totalAmt - gvAmount).toFixed(2);
        let cashamt = parseFloat(totalAmt - CardAmount - UPIAmount).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            PromotionalDiscountAmount: totalPromDiscount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            GrandTotal: parseFloat(totalAmt).toFixed(2),
            CashAmount: parseFloat(cashamt).toFixed(2),
            GVAmount: gvAmount.toFixed(2),
            CardAmount: CardAmount.toFixed(2),
            UPIAmount: UPIAmount.toFixed(2),
            CashDiscount: 0,
            ModifiedBy: userId,
        }));
    };

    const [itemdetails, setItemDetails] = useState([]);
    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setModalData({
            ...modalData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });

        // Use Array.prototype.find() to find the rate
        const selectedItemId = selectedOption ? selectedOption.value : '';

        const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            let quantity = parseFloat(modalData.Quantity) || 0;;
            let rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
            let gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
            let discountPercentage = parseFloat(selectedItemDetail.DiscountPercentage.toFixed(2)) || 0;

            let amount = (quantity * rate).toFixed(2);
            let discamt = ((rate * discountPercentage) / 100).toFixed(2)
            let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
            let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
            let grate = (rate - totdiscount).toFixed(2);

            // Promotional discount calculation with quantity validation
            let promodiscountamt = 0;
            let RateAfterDiscount = grate;
            let promodiscPercentage = parseFloat(formData.PromotionalDiscountPercentage) || 0;

            // Check if item has discount percentage > 0 and quantity threshold is met
            if (discountPercentage > 0) {
                const isEligible = validatePromoDiscountEligibility(invoicedeatils, formData.PromoDiscountQuantity);
                if (isEligible) {
                    promodiscountamt = ((grate * promodiscPercentage) / 100).toFixed(2);
                    // Set success message for promotional discount applied
                    if (promodiscPercentage > 0 && isPromotionalDiscountEnabled()) {
                        setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                    }
                } else {
                    // Set warning message for promotional discount not applied due to quantity
                    const discountedItemsCount = invoicedeatils.filter(item =>
                        parseFloat(item.DiscountPercentage) > 0
                    ).length;
                    const requiredQuantity = parseInt(formData.PromoDiscountQuantity) || 0;
                    if (requiredQuantity > 0 && isPromotionalDiscountEnabled()) {
                        setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                    }
                }
            }
            let RateAfterPromotionalDiscount = (RateAfterDiscount - promodiscountamt).toFixed(2);

            let salerate = (RateAfterPromotionalDiscount / (1 + gstrate / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);
            const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

            let cgst = 0;
            let sgst = 0;
            let igst = 0;

            if (!formData.GSTNumber) {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            } else {
                const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                if (gstNumberPrefix !== branchstate) {
                    igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                } else {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                }
            }

            const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

            setModalData({
                ...modalData,
                Rate: selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
                GSTRate: selectedItemDetail.GSTRate.toFixed(2),
                HSNCode: selectedItemDetail.HSNCode,
                DiscountPercentage: selectedItemDetail.DiscountPercentage.toFixed(2),
                AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                RateAfterDiscount: parseFloat(RateAfterDiscount).toFixed(2),
                PromotionalDiscountPercentage: Number(selectedItemDetail.DiscountPercentage) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",
                PromotionalDiscountAmount: parseFloat(promodiscountamt * quantity).toFixed(2),
                RateAfterPromotionalDiscount: parseFloat(RateAfterPromotionalDiscount).toFixed(2),
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                TaxableAmount: parseFloat(taxableamount).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2),
                SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
                balanceStock: selectedItemDetail.balanceStock,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '0.00',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                GSTRate: '0',
                HSNCode: '',
                DiscountPercentage: '',
                AdditionalDiscountPercentage: 0,
                balanceStock: 0,
            });
        }
    };

    const [isValid, setIsValid] = useState(true);
    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        const intValue = parseInt(value, 10);

        if (intValue > modalData.balanceStock) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }

        setModalData({
            ...modalData,
            [name]: value,
        });

        const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

        let quantity = parseFloat(value) || 0;
        let rate = parseFloat(modalData.Rate) || 0;
        let gstrate = parseFloat(modalData.GSTRate) || 0;
        let discountPercentage = parseFloat(modalData.DiscountPercentage) || 0;

        let amount = (quantity * rate).toFixed(2);
        let discamt = ((rate * discountPercentage) / 100).toFixed(2)
        let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
        let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);

        // Promotional discount calculation with quantity validation
        let promodiscountamt = 0;
        let RateAfterDiscount = grate;
        let promodiscPercentage = parseFloat(formData.PromotionalDiscountPercentage) || 0;

        // Check if item has discount percentage > 0 and quantity threshold is met
        if (discountPercentage > 0) {
            const isEligible = validatePromoDiscountEligibility(invoicedeatils, formData.PromoDiscountQuantity);
            if (isEligible) {
                promodiscountamt = ((grate * promodiscPercentage) / 100).toFixed(2);
                // Set success message for promotional discount applied
                if (promodiscPercentage > 0 && isPromotionalDiscountEnabled()) {
                    setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                }
            } else {
                // Set warning message for promotional discount not applied due to quantity
                const discountedItemsCount = invoicedeatils.filter(item =>
                    parseFloat(item.DiscountPercentage) > 0
                ).length;
                const requiredQuantity = parseInt(formData.PromoDiscountQuantity) || 0;
                if (requiredQuantity > 0 && isPromotionalDiscountEnabled()) {
                    setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                }
            }
        }
        let RateAfterPromotionalDiscount = (RateAfterDiscount - promodiscountamt).toFixed(2);

        let salerate = (RateAfterPromotionalDiscount / (1 + gstrate / 100)).toFixed(2);
        const taxableamount = (quantity * salerate).toFixed(2);
        const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

        let cgst = 0;
        let sgst = 0;
        let igst = 0;

        if (!formData.GSTNumber) {
            cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
        } else {
            const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

            if (gstNumberPrefix !== branchstate) {
                igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
            } else {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            }
        }

        const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

        setModalData({
            ...modalData,
            Quantity: quantity,
            Amount: amount,
            DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
            AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
            AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),

            RateAfterDiscount: parseFloat(RateAfterDiscount).toFixed(2),
            //PromotionalDiscountPercentage: parseFloat(promodiscPercentage).toFixed(2),
            PromotionalDiscountPercentage: Number(discountPercentage) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",

            PromotionalDiscountAmount: parseFloat(promodiscountamt * quantity).toFixed(2),
            RateAfterPromotionalDiscount: parseFloat(RateAfterPromotionalDiscount).toFixed(2),

            TaxableAmount: parseFloat(taxableamount).toFixed(2),
            CGSTAmount: parseFloat(cgst).toFixed(2),
            SGSTAmount: parseFloat(sgst).toFixed(2),
            IGSTAmount: parseFloat(igst).toFixed(2),
            TotalAmount: parseFloat(totalAmount).toFixed(2),
        });
    };


    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    // Helper function to check if promotional discount should be enabled
    const isPromotionalDiscountEnabled = () => {
        const { BillDate, PromoDiscountStartDate, PromoDiscountEndDate } = formData;

        // If any of the required dates are missing, disable promotional discount
        if (!BillDate || !PromoDiscountStartDate || !PromoDiscountEndDate) {
            return false;
        }

        const billDate = new Date(BillDate);
        const startDate = new Date(PromoDiscountStartDate);
        const endDate = new Date(PromoDiscountEndDate);

        // Check if bill date is between start and end dates (inclusive)
        return billDate >= startDate && billDate <= endDate;
    };

    const handleEdit = (index, field, value) => {
        setInvoicedeatils((prev = []) => {
            // ===== UPDATE ITEM VALUE =====
            const updatedItems = prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );

            const gvamt = parseFloat(formData?.GVAmount) || 0;

            // ===== RECALCULATE EACH ITEM =====
            const updatedItemData = updatedItems.map((item) => {
                const rate = parseFloat(item?.Rate) || 0;
                const gstrate = parseFloat(item?.GSTRate) || 0;
                const discountPct = parseFloat(item?.DiscountPercentage) || 0;
                const additionalPct = parseFloat(item?.AdditionalDiscountPercentage) || 0;
                const quantity = parseFloat(item?.Quantity) || 0;

                // Base amount
                const amount = quantity * rate;

                // Discounts (per unit)
                const discAmtPerUnit = (rate * discountPct) / 100;
                const addlDiscAmtPerUnit = (rate * additionalPct) / 100;
                const totalDiscPerUnit = discAmtPerUnit + addlDiscAmtPerUnit;

                // Net & sale rate
                const netRate = rate - totalDiscPerUnit;

                // Promotional discount calculation with quantity validation
                let promodiscountamt = 0;
                let RateAfterDiscount = netRate;
                let promodiscPercentage = parseFloat(formData?.PromotionalDiscountPercentage) || 0;

                // Check if item has discount percentage > 0 and quantity threshold is met
                if (discountPct > 0) {
                    const isEligible = validatePromoDiscountEligibility(updatedItems, formData?.PromoDiscountQuantity);
                    if (isEligible) {
                        promodiscountamt = (netRate * promodiscPercentage) / 100;
                        // Set success message for promotional discount applied
                        if (promodiscPercentage > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                        }
                    } else {
                        // Set warning message for promotional discount not applied due to quantity
                        const discountedItemsCount = updatedItems.filter(item =>
                            parseFloat(item.DiscountPercentage) > 0
                        ).length;
                        const requiredQuantity = parseInt(formData?.PromoDiscountQuantity) || 0;
                        if (requiredQuantity > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                        }
                    }
                }
                let RateAfterPromotionalDiscount = RateAfterDiscount - promodiscountamt;

                const saleRate = RateAfterPromotionalDiscount / (1 + gstrate / 100);

                // Taxable & GST
                const taxableAmount = quantity * saleRate;
                let cgst = 0, sgst = 0, igst = 0;

                const gstNumber = formData?.GSTNumber?.toString() || "";
                if (!gstNumber) {
                    // No GST number → CGST + SGST
                    cgst = (taxableAmount * (gstrate / 2)) / 100;
                    sgst = (taxableAmount * (gstrate / 2)) / 100;
                } else {
                    const gstPrefix = gstNumber.substring(0, 2);
                    if (gstPrefix !== branchstate) {
                        igst = (taxableAmount * gstrate) / 100; // Inter-state
                    } else {
                        cgst = (taxableAmount * (gstrate / 2)) / 100;
                        sgst = (taxableAmount * (gstrate / 2)) / 100;
                    }
                }

                const totalAmount = Math.round(taxableAmount + cgst + sgst + igst);

                return {
                    ...item,
                    Amount: amount.toFixed(2),
                    DiscountAmount: (discAmtPerUnit * quantity).toFixed(2),
                    AdditionalDiscountAmount: (addlDiscAmtPerUnit * quantity).toFixed(2),
                    AdditionalDiscountPercentage: additionalPct.toFixed(2),

                    RateAfterDiscount: RateAfterDiscount.toFixed(2),
                    //PromotionalDiscountPercentage: promodiscPercentage.toFixed(2),
                    PromotionalDiscountPercentage: Number(discountPct) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",

                    PromotionalDiscountAmount: (promodiscountamt * quantity).toFixed(2),
                    RateAfterPromotionalDiscount: RateAfterPromotionalDiscount.toFixed(2),

                    TaxableAmount: taxableAmount.toFixed(2),
                    CGSTAmount: cgst.toFixed(2),
                    SGSTAmount: sgst.toFixed(2),
                    IGSTAmount: igst.toFixed(2),
                    TotalAmount: totalAmount.toFixed(2),
                };
            });

            // ===== GRAND TOTALS =====
            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseFloat(item?.Quantity) || 0;
                    acc.Amount += parseFloat(item?.Amount) || 0;
                    acc.DiscountAmount += parseFloat(item?.DiscountAmount) || 0;
                    acc.AddiDiscountAmount += parseFloat(item?.AdditionalDiscountAmount) || 0;
                    acc.PromotionalDiscountAmount += parseFloat(item?.PromotionalDiscountAmount) || 0;
                    acc.TaxableAmount += parseFloat(item?.TaxableAmount) || 0;
                    acc.CGSTAmount += parseFloat(item?.CGSTAmount) || 0;
                    acc.SGSTAmount += parseFloat(item?.SGSTAmount) || 0;
                    acc.IGSTAmount += parseFloat(item?.IGSTAmount) || 0;
                    acc.TotalAmount += parseFloat(item?.TotalAmount) || 0;
                    return acc;
                },
                {
                    Quantity: 0,
                    Amount: 0,
                    DiscountAmount: 0,
                    AddiDiscountAmount: 0,
                    PromotionalDiscountAmount: 0,
                    TaxableAmount: 0,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    IGSTAmount: 0,
                    TotalAmount: 0,
                }
            );

            // ===== ADD PAYMENT DATA =====
            const CardAmount = parseFloat(formData?.CardAmount) || 0;
            const UPIAmount = parseFloat(formData?.UPIAmount) || 0;
            const totalDiscount = totals.DiscountAmount + totals.AddiDiscountAmount;

            // ===== FINAL CALL =====
            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totalDiscount,
                totals.PromotionalDiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                gvamt,
                CardAmount,
                UPIAmount
            );

            // ✅ Return updated items as new state
            return updatedItemData;
        });
    };


    return (
        <Fragment>
            <div className="pg-container">

            {/* ── Header ── */}
            <div className="pg-header">
                <h5 className="pg-title">Sale — Edit</h5>
                <div className="pg-header-actions">
                    <button className="pg-btn pg-btn-success" onClick={handleSubmit} disabled={isLoading}>
                        <DoneIcon />
                        {isLoading ? <CircularProgress size={14} color="inherit" /> : 'Save'}
                    </button>
                    <Link to="/SaleIndex" className="pg-btn pg-btn-danger">
                        <CloseIcon /> Cancel
                    </Link>
                </div>
            </div>

            {errorMessage   && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
            {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

            {/* ── Confirm Delete Modal ── */}
            {confirmRemove !== null && (
                <div className="pg-modal-backdrop" onClick={() => setConfirmRemove(null)}>
                    <div className="pg-modal-card" onClick={e => e.stopPropagation()}>
                        <div className="pg-modal-icon-wrap">
                            <WarningAmberIcon className="pg-modal-icon" />
                        </div>
                        <h6 className="pg-modal-title">Remove Item?</h6>
                        <p className="pg-modal-body">This item will be removed from the invoice. This action cannot be undone.</p>
                        <div className="pg-modal-actions">
                            <button className="pg-modal-btn pg-modal-btn-cancel" onClick={() => setConfirmRemove(null)}>
                                Cancel
                            </button>
                            <button className="pg-modal-btn pg-modal-btn-confirm" onClick={confirmRemoveRecord}>
                                <DeleteIcon style={{ fontSize: 15 }} /> Yes, Remove
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Main form card ── */}
            <div className="pg-card">

                {/* ── Row 1: Customer info ── */}
                <div className="pg-hpanel">
                    <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                        <span className="pg-hcell-label">Customer Name <span className="req">*</span></span>
                        <input className="pg-hcell-input" type="text" placeholder="Customer Name"
                            value={formData.CustomerName} onChange={handleChange} name="CustomerName"
                            readOnly={roleName !== 'SuperAdmin'} maxLength={100} />
                    </div>
                    <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                        <span className="pg-hcell-label">Bill Date <span className="req">*</span></span>
                        <input className={`pg-hcell-input${roleName !== 'SuperAdmin' ? ' pg-hcell-readonly' : ''}`} type="date"
                            value={formatDateForInput(formData.BillDate)} onChange={handleChange} name="BillDate"
                            disabled={roleName !== 'SuperAdmin'} />
                    </div>
                    <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                        <span className="pg-hcell-label">Bill No <span className="req">*</span></span>
                        <input className="pg-hcell-input pg-hcell-readonly" type="text" placeholder="Bill Number"
                            value={formData.BillNumber} onChange={handleChange} name="BillNumber" readOnly />
                    </div>
                    <div className="pg-hcell" style={{ flex: '0 0 80px' }}>
                        <span className="pg-hcell-label">Total Qty</span>
                        <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                            value={formData.TotalQuantity} onChange={handleChange} name="TotalQuantity" readOnly />
                    </div>
                    <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                        <span className="pg-hcell-label">Addt'l Disc Type</span>
                        <select className="pg-hcell-select" value={selectedDiscType}
                            disabled={roleName !== 'SuperAdmin'}
                            onChange={e => { setSelectedDiscType(e.target.value); setFormData(p => ({ ...p, DiscTypeId: e.target.value })); }}>
                            <option value="">Disc Type</option>
                            {dropdownDiscTypeOptions.map(c => <option key={c.Id} value={c.Id}>{c.Name}</option>)}
                        </select>
                    </div>
                    <div className="pg-hcell" style={{ flex: '0 0 80px' }}>
                        <span className="pg-hcell-label">Addt'l Disc %</span>
                        <input className="pg-hcell-input text-right" type="text" placeholder="0"
                            value={formData.AdditionalDiscountPercentage} onChange={handleChange} name="AdditionalDiscountPercentage"
                            readOnly={roleName !== 'SuperAdmin'}
                            onInput={e => { if (!/^\d*\.?\d{0,2}$/.test(e.target.value) && e.target.value !== '') e.target.value = e.target.value.slice(0, -1); }} />
                    </div>
                </div>

                {/* ── Row 2: Address / contact ── */}
                <div className="pg-hpanel" style={{ marginTop: 8 }}>
                    <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                        <span className="pg-hcell-label">Address</span>
                        <input className="pg-hcell-input" type="text" placeholder="Address"
                            value={formData.CustomerAddress} onChange={handleChange} name="CustomerAddress"
                            readOnly={roleName !== 'SuperAdmin'} maxLength={200} />
                    </div>
                    <div className="pg-hcell" style={{ flex: '2 1 0' }}>
                        <span className="pg-hcell-label">GST Number</span>
                        <input className="pg-hcell-input" type="text" placeholder="GST Number"
                            value={formData.GSTNumber} onChange={handleChange} name="GSTNumber"
                            readOnly={roleName !== 'SuperAdmin'} maxLength={15} />
                    </div>
                    <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                        <span className="pg-hcell-label">Phone No <span className="req">*</span></span>
                        <input className="pg-hcell-input" type="text" placeholder="Phone Number"
                            value={formData.ContactNumber} onChange={handleChange} name="ContactNumber"
                            readOnly={roleName !== 'SuperAdmin'} maxLength={15} />
                    </div>
                    <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                        <span className="pg-hcell-label">Sales Man <span className="req">*</span></span>
                        <select className="pg-hcell-select" value={selectedSalesMan}
                            disabled={roleName !== 'SuperAdmin'}
                            onChange={e => { setSelectedSalesMan(e.target.value); setFormData(p => ({ ...p, SalesManId: e.target.value })); }}>
                            <option value="">Sales Man</option>
                            {dropdownSalesManOptions.map(c => <option key={c.Id} value={c.Id}>{c.Name}</option>)}
                        </select>
                    </div>
                    <div className="pg-hcell" style={{ flex: '0 0 90px' }}>
                        <span className="pg-hcell-label">GWP/PWP <span className="req">*</span></span>
                        <select className="pg-hcell-select" value={selectedGWPorPWP}
                            onChange={e => { const v = e.target.value === 'true'; setSelectedGWPorPWP(v); setFormData(p => ({ ...p, GWPorPWPIncluded: v })); }}>
                            <option value={true}>YES</option>
                            <option value={false}>NO</option>
                        </select>
                    </div>
                </div>

                {errorMessageModel && <div className="pg-alert pg-alert-error">{errorMessageModel}</div>}

                {/* ── Item Add Bar ── */}
                <div className="pg-item-bar">
                    <div className="pg-field" style={{ flex: '1 1 220px' }}>
                        <label className="pg-label">Item Name</label>
                        <Select
                            value={selectedItems}
                            onChange={handleItemSelect}
                            options={itemsOptions}
                            placeholder="Search items…"
                            isSearchable
                            styles={{
                                control: b => ({ ...b, minHeight: 30, height: 30, fontSize: 12.5, borderColor: '#e2e8f0', borderRadius: 6 }),
                                valueContainer: b => ({ ...b, height: 30, padding: '0 8px' }),
                                indicatorsContainer: b => ({ ...b, height: 30 }),
                                menu: b => ({ ...b, zIndex: 1301, fontSize: 12.5 }),
                            }}
                        />
                    </div>
                    <div className="pg-field xnarrow">
                        <label className="pg-label">Quantity</label>
                        <input className="pg-input text-right" type="text" name="Quantity" placeholder="Qty"
                            value={modalData.Quantity} onChange={handleModalInputChange}
                            onInput={e => { if (!/^\d*\.?\d{0,2}$/.test(e.target.value) && e.target.value !== '') e.target.value = e.target.value.slice(0, -1); }} />
                        {!isValid && <span style={{ color: '#dc2626', fontSize: 11 }}>Exceeds stock</span>}
                    </div>
                    <div className="pg-field xnarrow">
                        <label className="pg-label">Promo Disc %</label>
                        <select className="pg-select" value={formData.PromotionalDiscountPercentage}
                            onChange={handleChange} name="PromotionalDiscountPercentage" disabled
                            style={{ textAlign: 'right' }}>
                            <option value="0">0%</option>
                            {promoDiscountOptions.map((o, i) => (
                                <option key={i} value={o.DiscountPercentage}>{o.DiscountPercentage}% (Min: {o.MinimumQuantity})</option>
                            ))}
                        </select>
                    </div>
                    <div className="pg-field xnarrow">
                        <label className="pg-label">Promo Disc Amt</label>
                        <input className="pg-input text-right" type="text"
                            value={formData.PromotionalDiscountAmount} onChange={handleChange}
                            name="PromotionalDiscountAmount" readOnly />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button className="pg-btn pg-btn-primary" onClick={saveModalData}>
                            <AddIcon /> Add Item
                        </button>
                    </div>
                </div>

                {/* ── Invoice Detail Table ── */}
                <div className="pg-invoice-table-wrap">
                    <table className="pg-invoice-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Item Name</th>
                                <th className="right">Qty</th>
                                <th className="right">MRP</th>
                                <th className="right">Disc %</th>
                                <th className="right">Addt'l Disc %</th>
                                <th className="right">Promo %</th>
                                <th className="right">Promo Amt</th>
                                <th className="right">Total</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoicedeatils.length === 0
                                ? <tr><td colSpan={10} style={{ textAlign: 'center', color: '#94a3b8', padding: 14 }}>No items added yet.</td></tr>
                                : invoicedeatils.map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ textAlign: 'center', width: 40 }}>{index + 1}</td>
                                        <td style={{ width: '35%' }}>{item.ItemName}</td>
                                        <td className="right" style={{ width: 80 }}>
                                            <input className="inline-input" type="text" value={item.Quantity}
                                                onChange={e => handleEdit(index, 'Quantity', e.target.value)}
                                                onInput={e => { if (!/^\d*\.?\d{0,2}$/.test(e.target.value) && e.target.value !== '') e.target.value = e.target.value.slice(0, -1); }} />
                                        </td>
                                        <td className="right">{item.Rate}</td>
                                        <td className="right">{item.DiscountPercentage}</td>
                                        <td className="right" style={{ width: 90 }}>
                                            <input className="inline-input" type="text" value={item.AdditionalDiscountPercentage}
                                                onChange={e => handleEdit(index, 'AdditionalDiscountPercentage', e.target.value)}
                                                onInput={e => { if (!/^\d*\.?\d{0,2}$/.test(e.target.value) && e.target.value !== '') e.target.value = e.target.value.slice(0, -1); }} />
                                        </td>
                                        <td className="right">{item.PromotionalDiscountPercentage}</td>
                                        <td className="right">{item.PromotionalDiscountAmount}</td>
                                        <td className="right" style={{ fontWeight: 700 }}>{item.TotalAmount}</td>
                                        <td style={{ textAlign: 'center', width: 40 }}>
                                            <IconButton size="small" onClick={() => removeRecord(index)}>
                                                <DeleteIcon style={{ color: '#dc2626', fontSize: 16 }} />
                                            </IconButton>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>

                {/* ── Totals Panel ── */}
                <div className="pg-totals-panel">

                    {/* Left: summary figures */}
                    <div className="pg-totals-left">
                        <div className="pg-totals-summary">
                            <div className="pg-tsum-row">
                                <span className="pg-tsum-label">Amount</span>
                                <span className="pg-tsum-value">{formData.TotalAmount}</span>
                            </div>
                            <div className="pg-tsum-row">
                                <span className="pg-tsum-label">Discount</span>
                                <span className="pg-tsum-value">{formData.DiscountAmount}</span>
                            </div>
                            <div className="pg-tsum-row">
                                <span className="pg-tsum-label">Cash Disc</span>
                                <span className="pg-tsum-value">{formData.CashDiscount}</span>
                            </div>
                            <div className="pg-tsum-row">
                                <span className="pg-tsum-label">GV Amount</span>
                                <input className="pg-tsum-input" type="text" placeholder="0.00"
                                    value={formData.GVAmount} onChange={handleChange} name="GVAmount"
                                    readOnly={roleName !== 'SuperAdmin'}
                                    onInput={e => { if (!/^\d*\.?\d{0,2}$/.test(e.target.value) && e.target.value !== '') e.target.value = e.target.value.slice(0, -1); }} />
                            </div>
                            <div className="pg-tsum-row">
                                <span className="pg-tsum-label">Net Amount</span>
                                <span className="pg-tsum-value">{formData.TaxableAmount}</span>
                            </div>
                        </div>

                        {/* Inter City Stock Transfer
                        <div style={{ marginTop: 10, paddingTop: 8, borderTop: '1px dashed rgba(200,212,224,0.6)' }}>
                            <label className="pg-checkbox-label">
                                <input type="checkbox" checked={formData.IsStockTransfer} name="IsStockTransfer"
                                    onChange={handleChange} disabled={roleName !== 'SuperAdmin'} />
                                Inter City Stock Transfer
                            </label>
                        </div> */}
                    </div>

                    {/* Divider */}
                    <div className="pg-totals-divider" />

                    {/* Right: Remarks + GST + Grand Total + Payments */}
                    <div className="pg-totals-right">

                        {/* Remarks */}
                        <div className="pg-totals-remarks">
                            <label className="pg-tpay-label">Remarks</label>
                            <textarea className="pg-remarks-textarea" placeholder="Remarks"
                                value={formData.Remarks} onChange={handleChange} name="Remarks"
                                readOnly={roleName !== 'SuperAdmin'} maxLength={200} />
                        </div>

                        {/* GST row */}
                        <div className="pg-totals-gst-row">
                            <div className="pg-tgst-cell">
                                <span className="pg-tgst-label">CGST</span>
                                <span className="pg-tgst-value">{formData.CGSTAmount}</span>
                            </div>
                            <div className="pg-tgst-cell">
                                <span className="pg-tgst-label">SGST</span>
                                <span className="pg-tgst-value">{formData.SGSTAmount}</span>
                            </div>
                            <div className="pg-tgst-cell">
                                <span className="pg-tgst-label">IGST</span>
                                <span className="pg-tgst-value">{formData.IGSTAmount}</span>
                            </div>
                            <div className="pg-tgst-cell">
                                <span className="pg-tgst-label">Round Off</span>
                                <span className="pg-tgst-value">{formData.RoundOff}</span>
                            </div>
                        </div>

                        {/* Grand Total highlight */}
                        <div className="pg-grand-total-bar">
                            <span className="pg-gt-label">Grand Total</span>
                            <span className="pg-gt-value">{formData.GrandTotal}</span>
                        </div>

                        {/* Payment row */}
                        <div className="pg-totals-pay-row">
                            <div className="pg-tpay-cell">
                                <label className="pg-tpay-label">Cash <span className="req">*</span></label>
                                <input className={`pg-tpay-input${formData.CashAmount < 0 ? ' cash-negative' : ''}`} type="text"
                                    value={formData.CashAmount} onChange={handleChange} name="CashAmount" readOnly />
                            </div>
                            <div className="pg-tpay-cell">
                                <label className="pg-tpay-label">Card <span className="req">*</span></label>
                                <input className="pg-tpay-input" type="text" placeholder="0.00"
                                    value={formData.CardAmount} onChange={handleChange} name="CardAmount"
                                    readOnly={roleName !== 'SuperAdmin'}
                                    onInput={e => { if (!/^\d*\.?\d{0,2}$/.test(e.target.value) && e.target.value !== '') e.target.value = e.target.value.slice(0, -1); }} />
                            </div>
                            <div className="pg-tpay-cell">
                                <label className="pg-tpay-label">UPI / RTGS / Other <span className="req">*</span></label>
                                <input className="pg-tpay-input" type="text" placeholder="0.00"
                                    value={formData.UPIAmount} onChange={handleChange} name="UPIAmount"
                                    readOnly={roleName !== 'SuperAdmin'}
                                    onInput={e => { if (!/^\d*\.?\d{0,2}$/.test(e.target.value) && e.target.value !== '') e.target.value = e.target.value.slice(0, -1); }} />
                            </div>
                        </div>

                        {/* Conditional extra fields */}
                        {(formData.CardAmount > 0 || formData.UPIAmount > 0 || formData.DiscTypeId == 1 || formData.DiscTypeId == 2) && (
                            <div className="pg-tpay-extra-row">
                                {formData.CardAmount > 0 && (
                                    <div className="pg-tpay-cell">
                                        <label className="pg-tpay-label">Card Type <span className="req">*</span></label>
                                        <select className="pg-tpay-select" value={selectedCardType}
                                            disabled={roleName !== 'SuperAdmin'}
                                            onChange={e => { setSelectedCardType(e.target.value); setFormData(p => ({ ...p, CardType: e.target.value })); }}>
                                            <option value="">Select Card Type</option>
                                            {dropdownCardTypeOptions.map(c => <option key={c.Id} value={c.Id}>{c.Name}</option>)}
                                        </select>
                                    </div>
                                )}
                                {formData.CardAmount > 0 && (
                                    <div className="pg-tpay-cell">
                                        <label className="pg-tpay-label">Card Number <span className="req">*</span></label>
                                        <input className="pg-tpay-input" type="text" placeholder="Card Number"
                                            value={formData.CardNumber} onChange={handleChange} name="CardNumber"
                                            readOnly={roleName !== 'SuperAdmin'} maxLength={20} />
                                    </div>
                                )}
                                {formData.UPIAmount > 0 && (
                                    <div className="pg-tpay-cell">
                                        <label className="pg-tpay-label">UPI / RTGS / Other No. <span className="req">*</span></label>
                                        <input className="pg-tpay-input" type="text" placeholder="UPI / RTGS / Other Number"
                                            value={formData.UPINumber} onChange={handleChange} name="UPINumber"
                                            readOnly={roleName !== 'SuperAdmin'} maxLength={20} />
                                    </div>
                                )}
                                {formData.DiscTypeId == 1 && (
                                    <div className="pg-tpay-cell">
                                        <label className="pg-tpay-label">SC Membership No. <span className="req">*</span></label>
                                        <input className="pg-tpay-input" type="text" placeholder="SC Membership Number"
                                            value={formData.SCMembershipNumber} onChange={handleChange} name="SCMembershipNumber"
                                            readOnly={roleName !== 'SuperAdmin'} maxLength={100} />
                                    </div>
                                )}
                                {formData.DiscTypeId == 2 && (
                                    <div className="pg-tpay-cell">
                                        <label className="pg-tpay-label">Voucher Number <span className="req">*</span></label>
                                        <input className="pg-tpay-input" type="text" placeholder="Voucher Number"
                                            value={formData.VoucherNumber} onChange={handleChange} name="VoucherNumber"
                                            readOnly={roleName !== 'SuperAdmin'} maxLength={100} />
                                    </div>
                                )}
                            </div>
                        )}

                    </div>
                </div>

            </div>{/* end pg-card */}

            <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
        </div>
        </Fragment >
    );
};

export default SaleEdit;
